import * as Setting from "../conf/Setting";

export function getConfigs() {
  return fetch(`${Setting.ServerUrl}/api/get-password-configs?`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

// 获取单个密码策略
export function getConfig(owner, uid) {
  return fetch(`${Setting.ServerUrl}/api/get-password-config?id=${owner}/${uid}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function addConfig(config) {
  const newConfig = Setting.deepCopy(config);
  return fetch(`${Setting.ServerUrl}/api/add-password-config`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newConfig),
  }).then(res => res.json());
}

export function updateConfig(config, owner, uid) {
  const newConfig = Setting.deepCopy(config);
  return fetch(`${Setting.ServerUrl}/api/update-password-config?id=${owner}/${uid}`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newConfig),
  }).then(res => res.json());
}

export function deleteConfig(config) {
  const newConfig = Setting.deepCopy(config);
  return fetch(`${Setting.ServerUrl}/api/delete-password-config`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newConfig),
  }).then(res => res.json());
}

export function checkPassword(organOwner, organId, userOwner, username, password) {
  const param = {
    organ: `${organOwner}/${organId}`,
    userId: `${userOwner}/${username}`,
    password: password,
  };
  return fetch(`${Setting.ServerUrl}/api/check-password`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(param),
  }).then(res => res.json());
}

// 校验密码是否过期
export function checkPasswordNeedChange(organOwner, organId, userOwner, username, password) {
  const param = {
    organ: `${organOwner}/${organId}`,
    userId: username === "" ? "" : `${userOwner}/${username}`,
    password: password,
  };
  return fetch(`${Setting.ServerUrl}/api/check-password-need-change`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(param),
  }).then(res => res.json());
}
